import { render, staticRenderFns } from "./KBC.vue?vue&type=template&id=c64c6a5a&"
import script from "./KBC.vue?vue&type=script&lang=js&"
export * from "./KBC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports